import actions from 'actions/tickets'
import userActions from 'actions/users'
import { createFormViewContainer } from 'factories/FormView'
import documentActions from 'actions/documents'
import ticketCategoryActions from 'actions/ticketCategories'
import { createDocumentsDispatchToProps } from 'helpers/formViews'
import Component from 'components/Tickets/FormView'

export default createFormViewContainer({
  actions,
  // extraStateToProps: (state, props) => ({
  //   ticketCategories: selectors.ticketCategories.selectOptions(state),
  //   users: selectors.users.selectOptions(state),
  // }),
  extraDispatchToProps: (dispatch, props) => ({
    newItem: (params) => dispatch(actions.newItem(params)),
    getUsers: (params) => dispatch(userActions.getItems(params)),
    sendCreateNotification: (ticketId, params) => dispatch(actions.sendCreateNotification(ticketId, params)),
    sendUpdateNotification: (ticketId, params) => dispatch(actions.sendUpdateNotification(ticketId, params)),
    createComment: (ticketId, params) => dispatch(actions.createComment(ticketId, params)),
    getTicketCategories: (params) => dispatch(ticketCategoryActions.getOptions(params)),
    ...createDocumentsDispatchToProps(dispatch, documentActions),
  }),
})(Component)
